import React from 'react';

import { formatPrice } from 'utilities/money';

interface Props {
  buttonName: string;
  installmentInterval: string;
  installmentIntervalCount: number;
  installmentPrice: number;
  isEuUser: boolean;
}

const InstallmentsTerms: React.FC<Props> = (props) => {
  const formattedInstallmentPrice = formatPrice(props.installmentPrice)

  const installmentScheduleDescription = () => {
    const interval = props.installmentInterval;
    const intervalCount = props.installmentIntervalCount;

    if (intervalCount > 1) {
      return `every ${intervalCount} ${interval}s for the next ${intervalCount * 3} ${interval}s`;
    } else {
      return `every ${interval} for the next 3 ${interval}s`;
    }
  };

  return (
    <>
      <p className="text-gray-light">
        By clicking "{props.buttonName}", you agree to our{' '}
        <a href="/installment-agreement" target="_blank">
          Installment Agreement
        </a>{' '}
        and authorize Magoosh to schedule a series of 4 payments from your card: 1 payment of{' '}
        {formattedInstallmentPrice} now and 3 payments of {formattedInstallmentPrice}{' '}
        {installmentScheduleDescription()}.{' '}
        <strong>
          There are no refunds for these installment payments outside of our 7-day money back
          guarantee or score guarantee policies.
        </strong>{' '}
        An email will be sent to you with the payment schedule.
        {!props.isEuUser && (
          <>
            {' '}
            You also agree to our{' '}
            <a href="/terms" target="_blank">
              Terms of Use
            </a>{' '}
            and{' '}
            <a href="/privacy" target="_blank">
              Privacy Policy.
            </a>
          </>
        )}
      </p>
    </>
  );
};

export default InstallmentsTerms;
